export const Footer = () => {

    let year = new Date().getFullYear();

    return (
        <div className="copyright text-center">
            <div className="wrapper">
                <p className="copy-footer-29">© {year} MINDRESET | ALL RIGHTS RESERVED.</p>
            </div>
        </div>
    )
}